import { api } from "./api";

const path = (p: string) => `/integrations/salesforce${p}`;

export const salesforceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSobjectDescribe: builder.query<
      Array<{ name: string; label: string }>,
      { sobject: string }
    >({
      query: ({ sobject }) => path(`/sobject/${sobject}/describe`),
    }),
    runQuery: builder.mutation<
      any,
      { selectedField: string; sfObject: string; sfId?: string }
    >({
      query: ({ selectedField, sfObject, sfId }) => ({
        url: path("/query"),
        method: "POST",
        body: { selectedField, sfObject, sfId },
      }),
    }),
    buildMappings: builder.mutation<any, { sobject: string }>({
      query: ({ sobject }) => ({
        url: path(`/build-mappings/${sobject}`),
        method: "POST",
      }),
    }),
    getSobjectData: builder.mutation<any, { sobject: string; id: string }>({
      query: ({ sobject, id }: { sobject: string; id: string }) => ({
        url: path(`/data/${sobject}`),
        method: "POST",
        body: { id },
      }),
    }),
  }),
});

export const {
  useLazyGetSobjectDescribeQuery,
  useGetSobjectDescribeQuery,
  useRunQueryMutation,
  useBuildMappingsMutation,
  useGetSobjectDataMutation,
} = salesforceApi;
